module.exports = __webpack_public_path__ + "img/表1-2比例.37d1af52.png";